<style lang="less" scoped>
    @import '~@/assets/less/article/preview.less';
    @import '~@/assets/less/article/preview_mobile.less';
</style>

<template>
    <div class="preview-container print-watermark" :class="[isMobile ? 'mobile_preview' : '']">
        <template v-if="target.type === 'doc' || target.type === 'docx'">
            <iframe
                scrolling="no" class="html-container" 
                :style="{height:docIframeHeight+'px'}"
                :src="target.previewUrl + '&page=' + doc.page"
                v-for="doc in targets" :key="doc.id">
            </iframe>
        </template>
        <template v-if="target.type === 'xls' || target.type === 'xlsx'">
            <iframe
                scrolling="no" class="html-container excel-container" height="800"
                :src="target.previewUrl + '&page=' + excel.page"
                v-for="excel in targets" :key="excel.id">
            </iframe>
        </template>
        <template v-if="target.type === 'ppt' || target.type === 'pptx' || target.type === 'pdf'">
            <div class="img-container" v-for="ppt in targets" :key="ppt.id">
                <img :src="target.previewUrl + '&page=' + ppt.page">
            </div>
        </template>

        <pre class="text-container" v-if="target.type == 'txt'">{{ txtContent }}</pre>

        <!-- <template v-if="target.type === 'txt'">
            <iframe
                 class="html-container" id="doc-container" height="1180"
                :src="target.previewUrl + '&page=1'">
            </iframe>
        </template> -->

        <div class="more-link" @click="loadAll" v-if="target.type != 'txt' && isShowMore">
            <a href="javascript:void(0);" class="blue">{{ `还有${ target.totalPage - page }页未读，` }}点击查看更多</a>
            <span class="bg-sprites icon-more"></span>
        </div>
    </div>
    
</template>

<script>

    export default {
        props: {
            target: {
                type: Object,
                default: () => ({}),
            },
            targetType: {
                type: String,
                default: 'file',
            },
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                previewUrl: "",
                targets: [{ page: 1 }],
                page: 1,
                isShowMore: false,
                handler: null,
                txtContent: "",
                docIframeHeight : 500,
            };
        },
        computed: {
           
        },
        created () {
            if(this.target.type === 'txt'){
                let txtContent = document.querySelector("#rich_content").innerHTML || "";
                document.querySelector("#rich_content").innerHTML = "";
                this.txtContent = txtContent;
            }
            
        },
        mounted () {
            if(this.isMobile){
                let bw = document.body.clientWidth;
                let bh = document.body.clientHeight;
                //.view-container里面有CSS padding 15px算出iframe宽度
                // let iframWidth = bw - 30;
                let iframWidth = bw*0.9;
                //preview库算scale的方式,(833,1178)
                //this.scaleRate = bw/833;
                let scaleRate = iframWidth/833;
                this.docIframeHeight = parseInt(1178*scaleRate);
                console.log("this.docIframeHeight = " + this.docIframeHeight)
                //this.docIframeHeight = parseInt(bh*this.scaleRate);

                //支持缩放
                let viewport = document.querySelector("meta[name=viewport]");
                let vcontent = viewport.getAttribute("content");
                vcontent = vcontent.replace("maximum-scale=1.0","maximum-scale=3.0").replace("user-scalable=no","user-scalable=yes");
                viewport.setAttribute('content', vcontent);

            }else{
                this.docIframeHeight = 1180;
            }
            this.loadPages();

            if (this.target.totalPage === 0) {
                this.targets = [];
            }

            if (this.page < this.target.totalPage) {
                this.isShowMore = true;
            }
        },
        beforeDestroy () {
            //$(window).off('scroll');
        },
        methods: {

            init (fn) {
                let that = this;
                let handler = this.handler = function(e){
                    //当前滚动条已经滚动展示内容的高度信息
                    let curTop = document.body.scrollTop || document.documentElement.scrollTop || 0;
                    //当前网页内容的总高度
                    let curPageHeight = document.body.scrollHeight;
                    let curWindow = window.innerHeight;
                    let delta = 150;
                    if(curTop + curWindow >= curPageHeight - delta){
                        //执行fn
                        that.loadPages();
                        fn && fn();
                    }
                };

                document.addEventListener("scroll", handler, false)
            },

            loadAll () {
                this.isShowMore = false;
                this.runScrollLoad();
            },
            runScrollLoad () {
                // 先推 5 页
                this.loadPages();
                if(!this.handler){
                    this.init();
                }

                // $(window).scroll(() => {
                //     if ($(window).scrollTop() >= $(document).height() - $(window).height() * 1.5) {
                //         this.loadPages();
                //     }
                // });
            },
            loadPages (pageCount = 5) {
                for (let i = 0; this.page < this.target.totalPage && i < pageCount; i++) {
                    this.page++;
                    this.targets.push({ page: this.page });
                }
            },
        },
    };
</script>
